module.exports = __webpack_public_path__ + "media/images/icon-prev-calendar-6b34526c88bbb963c123a4cdf0103e1c.svg";